export default __webpack_public_path__ + "static/media/terPresenca.9fd61b76.svg";